import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=4d06c0b2"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d06c0b2')) {
      api.createRecord('4d06c0b2', component.options)
    } else {
      api.reload('4d06c0b2', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=4d06c0b2", function () {
      api.rerender('4d06c0b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/auth/Register.vue"
export default component.exports